import React, { useState, useEffect } from 'react';
import UDIRowPopup, { UDIPopupField, UDIAddRowButton, useUDIRowPopup } from './UDIRowPopup.js';

const AdditionalProductDescription = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.EUProductUDI.AdditionalProductDescription",
    fieldTitle = "Additional Product Description",
    forceIsEditing = null
}) => {
    // Language Dictionary
    const languages = [
        { key: "en", value: "English" }, { key: "is", value: "Icelandic" },
        { key: "no", value: "Norwegian" }, { key: "tr", value: "Turkish" },
        { key: "bg", value: "Bulgarian" }, { key: "cs", value: "Czech" },
        { key: "da", value: "Danish" }, { key: "de", value: "German" },
        { key: "et", value: "Estonian" }, { key: "el", value: "Greek" },
        { key: "es", value: "Spanish" }, { key: "fr", value: "French" },
        { key: "hr", value: "Croatian" }, { key: "it", value: "Italian" },
        { key: "lv", value: "Latvian" }, { key: "lt", value: "Lithuanian" },
        { key: "hu", value: "Hungarian" }, { key: "mt", value: "Maltese" },
        { key: "nl", value: "Dutch" }, { key: "pl", value: "Polish" },
        { key: "pt", value: "Portuguese" }, { key: "ro", value: "Romanian" },
        { key: "sk", value: "Slovak" }, { key: "sl", value: "Slovenian" },
        { key: "fi", value: "Finnish" }, { key: "sv", value: "Swedish" },
        { key: "ga", value: "Irish" }
    ];

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);

    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        } catch {
            return [];
        }
    });

    const initialFormState = {
        Language: { Value: 'en', Text: 'English' },
        Description: ''
    };

    const [formData, setFormData] = useState(initialFormState);
    const [editingIndex, setEditingIndex] = useState(null);

    const handleLanguageChange = (e) => {
        const value = e.target.value;
        const text = e.target.options[e.target.selectedIndex].text;
        setFormData(prev => ({
            ...prev,
            Language: { Value: value, Text: text }
        }));
    };

    const handleDescriptionChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({ ...prev, Description: value }));
    };

    const handleSave = () => {
        const updatedItems = [...items];
        if (editingIndex !== null) {
            updatedItems[editingIndex] = formData;
        } else {
            updatedItems.push(formData);
        }

        // 1. Local State Update
        setItems(updatedItems);

        // 2. Global Update (Nested spread for EUProductUDI)
        setUDI(prevItem => ({
            ...prevItem,
            AdditionalProductDescription: updatedItems
        }));

        popup.close();
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);
        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            AdditionalProductDescription: updatedItems
        }));

        resetForm();
    };

    const handleEdit = (index) => {
        setFormData(items[index]);
        setEditingIndex(index);
        popup.openEdit();
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setEditingIndex(null);
    };

    const popup = useUDIRowPopup(resetForm);



    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);


    // --- Edit Mode ---
    return (

        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?



                            <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Language</th>
                                            <th>Description</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr
                                                key={index}
                                                className={editingIndex === index ? 'udi-complex-field-row-selected' : ''}
                                            >
                                                <td>{item.Language?.Text}</td>
                                                <td style={{ whiteSpace: 'pre-wrap' }}>{item.Description}</td>
                                                <td>
                                                    <button type="button" className="udiEditButton" onClick={() => handleEdit(index)}>
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                    <button type="button" className="udiRemoveButton" onClick={() => handleRemove(index)}>
                                                        <i className="fas fa-times-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <UDIAddRowButton label="Add Product Description" onClick={popup.openAdd} />

                                <UDIRowPopup
                                    isOpen={popup.isOpen}
                                    title={editingIndex !== null ? "Edit Product Description" : "Add Product Description"}
                                    saveLabel={editingIndex !== null ? "Save" : "Add"}
                                    onClose={popup.close}
                                    onSave={handleSave}
                                >
                                    <UDIPopupField label="Language">
                                        <select value={formData.Language.Value} onChange={handleLanguageChange}>
                                            {languages.map(lang => <option key={lang.key} value={lang.key}>{lang.value}</option>)}
                                        </select>
                                    </UDIPopupField>
                                    <UDIPopupField label="Description">
                                        <textarea value={formData.Description} onChange={handleDescriptionChange} rows={4} />
                                    </UDIPopupField>
                                </UDIRowPopup>

                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(items)} />
                            </div>



                            :


                            <>

                                <table className="dataTable" style={{ borderWidth: '1px', width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Language</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.Language?.Text}</td>
                                                <td style={{ whiteSpace: 'pre-wrap' }}>{item.Description}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/*
						        <input
							        type="button"
							        className="udiActionButton"
							        value="Edit"
							        onClick={() => changeIsEditingField(true)}
						        />
                                */}


                            </>

                        }

                    </div>

                </div>
            </div>
        </div>



    );
};

export default AdditionalProductDescription;